import React, { useEffect, useState, useContext } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import {
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material';
import './BoardCodePage.css';

function BoardCodeDetailPage() {
  const { id } = useParams();
  const [code, setCode] = useState(null);
  const [boardAuths, setBoardAuths] = useState([]);
  const navigate = useNavigate();
  const { token } = useContext(AuthContext);

  useEffect(() => {
    const fetchCode = async () => {
      try {
        const res = await axios.get(`/api/board-codes/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setCode(res.data);
      } catch (err) {
        console.error('게시판 코드 조회 실패:', err);
        alert('코드를 불러오지 못했습니다');
      }
    };

    const fetchAuths = async () => {
      try {
        const res = await axios.get(`/api/board-codes/auths/board-code-id/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setBoardAuths(Array.isArray(res.data) ? res.data : []);
      } catch (err) {
        console.error('게시판 권한 조회 실패:', err);
        setBoardAuths([]);
      }
    };

    fetchCode();
    fetchAuths();
  }, [id, token]);

  const handleDelete = async () => {
    try {
      await axios.patch(`/api/board-codes/${id}/deactivate`, {}, {
        headers: { Authorization: `Bearer ${token}` },
      });
      alert('게시판 코드가 삭제되었습니다');
      navigate('/board-codes');
    } catch (err) {
      console.error('게시판 코드 삭제 실패:', err);
      alert('삭제 중 오류 발생');
    }
  };

  if (!code) {
    return (
      <div className="boardcodes-empty">
        <div className="spinner-border text-secondary" role="status" />
        <p>불러오는 중...</p>
      </div>
    );
  }

  return (
    <div className="view-boardcode container-fluid">
      <div className="row">
        <div className="col-12">

          {/* 헤더 영역 (상단 고정) */}
          <div className="boardcode-header-fixed">
            <button
              className="btn btn-warning me-2"
              onClick={() => navigate(`/board-codes/${id}/edit`)}
            >
              수정
            </button>
            <button
              className="btn btn-danger me-2"
              onClick={handleDelete}
            >
              삭제
            </button>
            <button
              className="btn btn-outline-secondary"
              onClick={() => navigate('/board-codes')}
            >
              목록으로
            </button>
          </div>

          {/* 기본 정보 박스 */}
          <div className="boardcode-body boardcode-basic">
            <h6>📑 게시판 코드 기본정보</h6>
            <p><strong>코드:</strong> {code.code}</p>
            <p><strong>이름:</strong> {code.name}</p>
            <p><strong>설명:</strong> {code.description}</p>
            <p><strong>상태:</strong> {code.is_active ? '활성' : '비활성'}</p>
          </div>

          {/* 권한 목록 박스 */}
          <div className="boardcode-body boardcode-auths">
            <Typography variant="h6" gutterBottom>
              🔐 권한 목록
            </Typography>
            {boardAuths.length > 0 ? (
              <TableContainer component={Paper}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>대상 유형</TableCell>
                      <TableCell>대상 ID</TableCell>
                      <TableCell>권한 유형</TableCell>
                      <TableCell>생성일</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {boardAuths.map((auth) => (
                      <TableRow key={`${auth.target_type}-${auth.target_id}-${auth.auth_type}`}>
                        <TableCell>{auth.target_type}</TableCell>
                        <TableCell>{auth.target_id}</TableCell>
                        <TableCell>{auth.auth_type}</TableCell>
                        <TableCell>{new Date(auth.created_at).toLocaleDateString()}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            ) : (
              <Typography variant="body2" color="textSecondary">
                등록된 권한이 없습니다.
              </Typography>
            )}
          </div>

        </div>
      </div>
    </div>
  );
}

export default BoardCodeDetailPage;